import { render, staticRenderFns } from "./OutcallShare.vue?vue&type=template&id=06adedf0&scoped=true&"
import script from "./OutcallShare.vue?vue&type=script&lang=js&"
export * from "./OutcallShare.vue?vue&type=script&lang=js&"
import style0 from "./OutcallShare.vue?vue&type=style&index=0&id=06adedf0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06adedf0",
  null
  
)

export default component.exports